<template>
    <div :class="{'display-inline': !isAlert, 'small-alert alert-info': isOpen && isAlert, 'small-alert alert-danger': !isOpen && isAlert}"
         :title="isOpen ? 'open' : 'closed'"
    >
        <strong>
            <span>
                <i :class="{'fa fa-exclamation-circle text-primary': isOpen, 'fa fa-times-circle text-danger': !isOpen}" aria-hidden="true" />
            </span>
        </strong>
        <span v-if="includeText">
            {{ isOpen ? "Open" : "Closed" }}
        </span>
    </div>
</template>

<script>
export default {
    name: "OpenCloseIssues",
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        includeText: {
            type: Boolean,
            default: true,
        },
        isAlert: {
            type: Boolean,
            default: true,
        },
    },
}
</script>

<style scoped>
.small-alert {
    border-radius: 4px;
    padding: 5px;
    display: inline-block;
    font-size: 16px;
}
.display-inline {
    display: inline;
}
</style>
